import { render, staticRenderFns } from "./ProjectSectionAddons.vue?vue&type=template&id=9901c832"
import script from "./ProjectSectionAddons.vue?vue&type=script&lang=js"
export * from "./ProjectSectionAddons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports